/** One Blend Lots / Drying & Shelling / Load Truck to Plant document at the dryer. */
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import type { DryerStage } from "@/features/dryer/api";
import { DryerStagePage } from "@/features/dryer/components/stage-page";

const STAGES: readonly DryerStage[] = ["blend", "drying", "load"];

export const Route = createFileRoute("/_app/dryer/$stage/$id")({
  beforeLoad: ({ params }) => {
    if (!useAuth.getState().can("document.view")) throw redirect({ to: "/" });
    if (!STAGES.includes(params.stage as DryerStage)) throw notFound();
  },
  component: Page,
});

function Page() {
  const { stage, id } = Route.useParams();
  return (
    <DryerStagePage
      key={`${stage}-${id}`}
      stage={stage as DryerStage}
      id={Number(id)}
    />
  );
}
